import React, { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import { PaginateList } from 'src/app/common/types/common-types';
import { useDataProvider } from 'src/app/common/utils';
import { fetchList, MdrtPassportBackgroundListParams } from '../../../network/mdrtPassportBackgroundCrud';
import { MdrtPassportBackgroundItem } from '../../../types/mdrt-passport-background-types';
import MdrtPassportBackgroundList from './components/MdrtPassportBackgroundList';

type ListingPageProps = {} & ParamsProps;

const initialState: MdrtPassportBackgroundListParams = {
  page: 1,
  limit: 5,
};

const paramsInitiator = (initialParams?: Record<string, string>): MdrtPassportBackgroundListParams => {
  return initialParams
    ? {
        page: 1,
        limit: 5,
      }
    : initialState;
};

const MdrtPassportBackgroundListingPage: FC<ListingPageProps> = ({ initialParams, onChangeQueryParams }) => {
  const dispatch = useDispatch();

  const [filterState, setFilterState] = useState<MdrtPassportBackgroundListParams>(paramsInitiator(initialParams));
  const [itemList, setItemList] = useState<PaginateList<MdrtPassportBackgroundItem>>();

  const { isLoading, refreshData } = useDataProvider<PaginateList<MdrtPassportBackgroundItem>>(
    async () => {
      try {
        if (onChangeQueryParams) {
          onChangeQueryParams(filterState);
        }
        return await fetchList(filterState, dispatch);
      } catch (err) {}
    },
    setItemList,
    false,
  );

  return (
    <>
      <MdrtPassportBackgroundList
        isLoading={isLoading}
        onRefresh={refreshData}
        itemList={itemList}
        onChangePage={(page, rowsPerPage) => {
          setFilterState({
            ...filterState,
            page,
            limit: rowsPerPage,
          });
          refreshData();
        }}
      />
    </>
  );
};

export default MdrtPassportBackgroundListingPage;
